import _ from 'lodash'
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import BootUpBadge from '../../../components/BootUpBadge'
import MessageRender from '../../../components/Message/MessageRender'
import PlaylistEditConfirmation from '../../../playlist/components/PlaylistEditConfirmation'
import clsx from 'clsx'
import MessagesModal from '../../../components/Message/MessagesModal'
import DynamicKeys from './DynamicKeys'
import DeviceBadge from '../DeviceBadge'
import PlaylistPreview from '../../../playlist/components/PlayListTable/PlaylistPreview'
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap'
import RemoveValidationModal from './RemoveValidationModal'
import SetValidationModal from './SetValidationModal'

interface InputProps {
  playlist?: any
  configuration: any
  removePlaylist: (index: any) => void
  index: number
  isDashboard: boolean
  type: any
  selectedIcon: any
  triggers?: any
  Schedules?: any
  isValidationAllowed?: any
  isValidationEnabledForCustomer?: any
  hasTempChanges?: any
  configureList?: any
  resetConfiguration?: any
}

const PlaylistRow: React.FC<InputProps> = ({
  playlist,
  removePlaylist,
  index,
  configuration,
  isDashboard,
  type,
  selectedIcon,
  triggers,
  Schedules,
  isValidationAllowed,
  isValidationEnabledForCustomer,
  hasTempChanges,
  configureList,
  resetConfiguration,
}) => {
  const [showWarning, setShowWarning] = useState<boolean>(false)
  const history = useNavigate()
  const [isMessagesModal, setIsMessagesModal] = useState(false)
  const [showRemoveValidationModal, setShowRemoveValidationModal] = useState<boolean>(false)
  const [showValidationModal, setShowValidationModal] = useState<boolean>(false)

  const confirm = () => {
    setShowWarning(false)
    history(`/playlists/edit/${playlist.Id}`)
  }

  const close = () => {
    setShowWarning(false)
  }

  const TRIGGER_MSG =
    'This playlist is automatically activated by a hardware trigger and cannot be removed. Remove the trigger first to remove the playlist.'

  const SCHEDULE_MSG =
    'This playlist is automatically activated by a schedule and cannot be removed. Remove the schedule first to remove the playlist.'

  const isAutoTriggeredPlaylist = (playlistId: number, triggers: any[] = []): boolean => {
    return triggers.some((trigger) => {
      const playlists = [
        ...(trigger?.ShowCommand?.PlaylistsToShow || []),
        ...(trigger?.HighShowCommand?.PlaylistsToShow || []),
        ...(trigger?.LowShowCommand?.PlaylistsToShow || []),
      ]

      return playlists.some((p: any) => p.Id === playlistId)
    })
  }

  const isScheduledPlaylist = (playlistId: number, Schedules: any[] = []): boolean => {
    return Schedules.some((schedule) => {
      const playlists = [
        ...(schedule?.ShowAll?.Playlists || []),
        ...(schedule?.ShowFront?.Playlists || []),
        ...(schedule?.ShowRear?.Playlists || []),
      ]

      return playlists.some((p: any) => p.Id === playlistId)
    })
  }

  const isTriggered = isAutoTriggeredPlaylist(configuration?.PlaylistId, triggers)
  const isScheduled = isScheduledPlaylist(configuration?.PlaylistId, Schedules)

  const isDisabled = isTriggered || isScheduled

  const popover = (
    <Popover id='remove-popover' className='max-width-300px'>
      <Popover.Body className='custom-tooltip'>
        {isTriggered && <div className='mb-2'>{TRIGGER_MSG}</div>}
        {isScheduled && <div>{SCHEDULE_MSG}</div>}
      </Popover.Body>
    </Popover>
  )

  const validationPopover = (
    <Popover id='validation-popover' className='max-width-300px'>
      <Popover.Body>
        You have unsaved changes in the configuration. You must deploy these before you can set the
        validation playlist.
      </Popover.Body>
    </Popover>
  )

  return (
    <>
      <tr
        key={configuration?.PlaylistId}
        className={clsx('', type == 'integrators' ? 'bg-grey' : '')}
      >
        {type == 'normal' && (
          <>
            <td>
              {configuration?.PlaylistName} <BootUpBadge playlist={playlist} />
            </td>
            {isDashboard != true && (
              <td>
                {playlist?.Description} <DeviceBadge playlist={playlist} />
              </td>
            )}
            {/* <td className={clsx('', isDashboard == true ? 'd-flex images-preview' : '')}> */}
            <td
              className={clsx(
                '',
                (isDashboard == true &&
                  playlist &&
                  (!playlist.FrontPreviewUrl || !playlist.RearPreviewUrl)) ||
                  selectedIcon == 'Image'
                  ? 'd-flex images-preview border-0'
                  : ''
              )}
            >
              {playlist &&
                (playlist.FrontPreviewUrl || playlist.RearPreviewUrl) &&
                selectedIcon != 'Image' ? (
                <div
                  className={clsx('d-flex ', isDashboard != true ? 'gap-5' : '')}
                  style={isDashboard == true ? { columnGap: '8px' } : {}}
                >
                  {playlist.FrontPreviewUrl && playlist.ShowAll && (
                    <PlaylistPreview
                      selectedIcon={selectedIcon}
                      previewUrl={playlist.FrontPreviewUrl}
                      pngPreviewUrl={playlist.ShowAll[0]?.PreviewUrl}
                      height={isDashboard == true ? '30px' : null}
                      width={isDashboard == true ? 'auto' : null}
                    />
                  )}
                  {playlist.FrontPreviewUrl && playlist.ShowFront && (
                    <PlaylistPreview
                      selectedIcon={selectedIcon}
                      previewUrl={playlist.FrontPreviewUrl}
                      pngPreviewUrl={playlist.ShowFront[0]?.PreviewUrl}
                      height={isDashboard == true ? '30px' : null}
                      width={isDashboard == true ? 'auto' : null}
                    />
                  )}
                  {playlist.RearPreviewUrl && playlist.ShowRear && (
                    <PlaylistPreview
                      selectedIcon={selectedIcon}
                      previewUrl={playlist.RearPreviewUrl}
                      pngPreviewUrl={playlist.ShowRear[0]?.PreviewUrl}
                      height={isDashboard == true ? '30px' : null}
                      width={isDashboard == true ? 'auto' : null}
                    />
                  )}
                </div>
              ) : (
                <div
                  className={clsx(
                    'd-flex flex-row',
                    isDashboard != true ? 'flex-wrap' : 'msgs-parent'
                  )}
                >
                  <div
                    className={clsx(
                      'd-flex flex-row',
                      isDashboard != true ? 'flex-wrap gap-5' : ''
                    )}
                    style={
                      isDashboard == true
                        ? { maxWidth: '240px', display: 'flex', columnGap: '8px' }
                        : {}
                    }
                  >
                    {playlist?.ShowAll &&
                      playlist.ShowAll.map((msg: any, i: number) => {
                        return (
                          <React.Fragment key={`img-${playlist.Id}-${i}`}>
                            <MessageRender
                              message={msg}
                              height={isDashboard == true ? '30px' : ''}
                            ></MessageRender>
                          </React.Fragment>
                        )
                      })}
                    {playlist?.ShowFront &&
                      playlist.ShowFront.map((msg: any, i: number) => {
                        return (
                          <React.Fragment key={`img-${playlist.Id}-${i}`}>
                            <MessageRender
                              message={msg}
                              height={isDashboard == true ? '30px' : ''}
                            ></MessageRender>
                          </React.Fragment>
                        )
                      })}
                    {playlist?.ShowRear &&
                      playlist.ShowRear.map((msg: any, i: number) => {
                        return (
                          <React.Fragment key={`img-${playlist.Id}-${i}`}>
                            <MessageRender
                              message={msg}
                              height={isDashboard == true ? '30px' : ''}
                            ></MessageRender>
                          </React.Fragment>
                        )
                      })}
                  </div>
                  <div className='imgs-expand'>
                    <div
                      className='img-dots'
                      onClick={(e) => {
                        e.stopPropagation()
                        setIsMessagesModal(true)
                      }}
                    >
                      <div>
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* {isDashboard == true &&
              <i style={{ cursor: "pointer" }} className="fas fa-ellipsis-h fs-2 d-flex align-items-center ml-4"></i>
            } */}
            </td>

            {isDashboard != true && (
              <td>
                {isTriggered && (
                  <Badge className='bootup-badge ms-2'>
                    <span className='store-text'>AUTO TRIG</span>
                  </Badge>
                )}

                {isScheduled && (
                  <Badge className='bootup-badge ms-2 vacant-badge'>
                    <span className='store-text'>SCHEDULED</span>
                  </Badge>
                )}
              </td>
            )}
            {isDashboard !== true && isValidationAllowed && (
              <td>
                {configuration?.Role === 'VALIDATION_SUCCESS' && (
                  <Badge className='bootup-badge vacant-badge ms-2'>
                    <span className='store-text'>VALIDATION</span>
                  </Badge>
                )}
              </td>
            )}
            {isDashboard != true && (
              <td>
                <div className='d-flex gap-2 justify-content-end'>
                  {isValidationEnabledForCustomer && (
                    <>
                      {configuration?.Role === 'VALIDATION_SUCCESS' ? (
                        hasTempChanges ? (
                          <OverlayTrigger
                            placement='top'
                            trigger={['click', 'hover', 'focus']}
                            overlay={validationPopover}
                          >
                            <span>
                              <button
                                className='btn btn-sm btn-secondary text-nowrap'
                                disabled
                                style={{ cursor: 'not-allowed' }}
                              >
                                Remove Validation
                              </button>
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <button
                            className='btn btn-sm btn-danger text-nowrap'
                            onClick={() => setShowRemoveValidationModal(true)}
                          >
                            Remove Validation
                          </button>
                        )
                      ) : hasTempChanges ? (
                        <OverlayTrigger
                          placement='top'
                          trigger={['click', 'hover', 'focus']}
                          overlay={validationPopover}
                        >
                          <span>
                            <button
                              className='btn btn-sm btn-secondary text-nowrap'
                              disabled
                              style={{ cursor: 'not-allowed' }}
                            >
                              Set Validation
                            </button>
                          </span>
                        </OverlayTrigger>
                      ) : (
                        <button
                          className='btn btn-sm btn-primary text-nowrap'
                          onClick={() => setShowValidationModal(true)}
                        >
                          Set Validation
                        </button>
                      )}
                    </>
                  )}
                  <button className='btn btn-sm btn-primary' onClick={() => setShowWarning(true)}>
                    Edit
                  </button>

                  {isDisabled ? (
                    <OverlayTrigger
                      placement='top'
                      trigger={['click', 'hover', 'focus']}
                      delay={{ show: 0, hide: 50 }}
                      overlay={popover}
                      rootClose
                    >
                      <a>
                        <button
                          className='btn btn-sm btn-secondary'
                          data-bs-toggle='popover'
                          disabled
                        >
                          Remove
                        </button>
                      </a>
                    </OverlayTrigger>
                  ) : (
                    <button className='btn btn-sm btn-danger' onClick={() => removePlaylist(index)}>
                      Remove
                    </button>
                  )}
                </div>
              </td>
            )}
          </>
        )}
        {type == 'integrators' && (
          <>
            <td>{playlist?.CallWord}</td>
            <td>{playlist?.Title}</td>
            <td>
              {playlist?.ShowAll && playlist?.ShowAll.length > 0 && (
                <>
                  {playlist?.ShowAll &&
                    playlist.ShowAll.map((msg: any, i: number) => {
                      return (
                        <React.Fragment key={`img-${playlist.Id}-${i}`}>
                          <DynamicKeys msg={msg} />
                        </React.Fragment>
                      )
                    })}
                </>
              )}

              {playlist?.ShowFront && playlist?.ShowFront.length > 0 && (
                <>
                  {playlist?.ShowFront &&
                    playlist.ShowFront.map((msg: any, i: number) => {
                      return (
                        <React.Fragment key={`img-${playlist.Id}-${i}`}>
                          <DynamicKeys msg={msg} />
                        </React.Fragment>
                      )
                    })}
                </>
              )}
              {playlist?.ShowRear && playlist?.ShowRear.length > 0 && (
                <>
                  {playlist?.ShowRear &&
                    playlist.ShowRear.map((msg: any, i: number) => {
                      return (
                        <React.Fragment key={`img-${playlist.Id}-${i}`}>
                          <DynamicKeys msg={msg} />
                        </React.Fragment>
                      )
                    })}
                </>
              )}
            </td>
            <td className={clsx('')}>
              <div className={clsx('d-flex flex-row flex-wrap')}>
                <div className={clsx('d-flex flex-row flex-wrap gap-5 align-items-center')}>
                  {playlist?.ShowAll && playlist?.ShowAll.length > 0 && (
                    <>
                      Front & Rear
                      {playlist?.ShowAll &&
                        playlist.ShowAll.map((msg: any, i: number) => {
                          return (
                            <React.Fragment key={`img-${playlist.Id}-${i}`}>
                              <MessageRender message={msg}></MessageRender>
                            </React.Fragment>
                          )
                        })}
                    </>
                  )}

                  {playlist?.ShowFront && playlist?.ShowFront.length > 0 && (
                    <div className='d-flex flex-row flex-wrap gap-5 align-items-center w-100'>
                      Front
                      {playlist?.ShowFront &&
                        playlist.ShowFront.map((msg: any, i: number) => {
                          return (
                            <React.Fragment key={`img-${playlist.Id}-${i}`}>
                              <MessageRender message={msg}></MessageRender>
                            </React.Fragment>
                          )
                        })}
                      {playlist?.ShowRear && playlist?.ShowRear.length > 0 && (
                        <hr className='solid w-100 m-0' />
                      )}
                    </div>
                  )}
                  {playlist?.ShowRear && playlist?.ShowRear.length > 0 && (
                    <div className='d-flex flex-row flex-wrap gap-5 align-items-center w-100'>
                      Rear
                      {playlist?.ShowRear &&
                        playlist.ShowRear.map((msg: any, i: number) => {
                          return (
                            <React.Fragment key={`img-${playlist.Id}-${i}`}>
                              <MessageRender message={msg}></MessageRender>
                            </React.Fragment>
                          )
                        })}
                    </div>
                  )}
                </div>
                <div className='imgs-expand'>
                  <div
                    className='img-dots'
                    onClick={(e) => {
                      e.stopPropagation()
                      setIsMessagesModal(true)
                    }}
                  >
                    <div>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </>
        )}
      </tr>
      <PlaylistEditConfirmation
        isOpenModal={showWarning}
        confirm={confirm}
        close={close}
      ></PlaylistEditConfirmation>
      <MessagesModal
        show={isMessagesModal}
        close={() => setIsMessagesModal(false)}
        playlist={playlist}
      />
      {showRemoveValidationModal && (
        <RemoveValidationModal
          showRemoveValidationModal={showRemoveValidationModal}
          onClose={() => setShowRemoveValidationModal(false)}
          configurationId={configureList?.ConfigurationId}
          resetConfiguration={resetConfiguration}
        />
      )}
      {showValidationModal && (
        <SetValidationModal
          showValidationModal={showValidationModal}
          onClose={() => setShowValidationModal(false)}
          configuration={configuration}
          playLists={playlist}
          resetConfiguration={resetConfiguration}
          configurationId={configureList?.ConfigurationId}
        />
      )}
    </>
  )
}

export default PlaylistRow
